/**
 * This file is part of ONP.
 *
 * Copyright (c) Opensoft (http://opensoftdev.com)
 *
 * The unauthorized use of this code outside the boundaries of
 * Opensoft is prohibited.
 *
 * @author Vladimir Prudilin <vladimir.prudilin@opensoftdev.ru>
 */

define(['backbone'], function(backbone) {
    return backbone.Model.extend({
        defaults: {
            quantity: 0,
            maxQuantity: 0,
            itemId: null,
            mailingClass: 'first',
            price: 0,
            currency: null,
            availableMailingClasses: []
        }
    });
});
